export enum PaymentOptionDataHooks {
  PaymentOption = 'Payment-option',
  Label = 'label',
  ValidUntil = 'valid-until',
  Suffix = 'suffix',
}
